/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RegisterAccountResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The RegisterAccountResource model module.
   * @module model/RegisterAccountResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RegisterAccountResource</code>.
   * A resource used to create a new user account.
   * @alias module:model/RegisterAccountResource
   * @class
   * @param name {String} Required. The name of the account. It can't be duplicated, must be unique in the GIS Server.
   * @param nickName {String} Required. The nick name of the account.
   * @param email {String} Required. The Email address of the account. It can't be duplicated, must be unique in the GIS Server.
   * @param password {String} Required. The password of the account.
   * @param confirmPassword {String} Required. The confirm password. It must be identity to the \"Password\" field.
   * @param timeZone {String} Required. The timezone of the account. It will be used to convert some data records datetime. For example, the statistics records. Defaults to \"UTC\".
   */
  var exports = function(name, nickName, email, password, confirmPassword, timeZone) {
    var _this = this;

    _this['name'] = name;
    _this['nickName'] = nickName;
    _this['email'] = email;
    _this['password'] = password;
    _this['confirmPassword'] = confirmPassword;
    _this['timeZone'] = timeZone;

  };

  /**
   * Constructs a <code>RegisterAccountResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RegisterAccountResource} obj Optional instance to populate.
   * @return {module:model/RegisterAccountResource} The populated <code>RegisterAccountResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('nickName')) {
        obj['nickName'] = ApiClient.convertToType(data['nickName'], 'String');
      }
      if (data.hasOwnProperty('email')) {
        obj['email'] = ApiClient.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('password')) {
        obj['password'] = ApiClient.convertToType(data['password'], 'String');
      }
      if (data.hasOwnProperty('confirmPassword')) {
        obj['confirmPassword'] = ApiClient.convertToType(data['confirmPassword'], 'String');
      }
      if (data.hasOwnProperty('timeZone')) {
        obj['timeZone'] = ApiClient.convertToType(data['timeZone'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
    }
    return obj;
  }

  /**
   * Required. The name of the account. It can't be duplicated, must be unique in the GIS Server.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * Required. The nick name of the account.
   * @member {String} nickName
   */
  exports.prototype['nickName'] = undefined;
  /**
   * Required. The Email address of the account. It can't be duplicated, must be unique in the GIS Server.
   * @member {String} email
   */
  exports.prototype['email'] = undefined;
  /**
   * Required. The password of the account.
   * @member {String} password
   */
  exports.prototype['password'] = undefined;
  /**
   * Required. The confirm password. It must be identity to the \"Password\" field.
   * @member {String} confirmPassword
   */
  exports.prototype['confirmPassword'] = undefined;
  /**
   * Required. The timezone of the account. It will be used to convert some data records datetime. For example, the statistics records. Defaults to \"UTC\".
   * @member {String} timeZone
   */
  exports.prototype['timeZone'] = undefined;
  /**
   * Optional. The desciprition of the account.
   * @member {String} description
   */
  exports.prototype['description'] = undefined;



  return exports;
}));



